import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import type { CustomIcons } from "./Icons.type";

const ExercisesIcons: CustomIcons = {
  extraSmall: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2.3252"
        y="2.85004"
        width="2.1"
        height="6.30001"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M2.325 3.90009H1.25C0.973858 3.90009 0.75 4.12394 0.75 4.40009V7.60009C0.75 7.87623 0.973858 8.10009 1.25 8.10009H2.325"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M9.675 8.10004L10.75 8.10004C11.0261 8.10004 11.25 7.87618 11.25 7.60004L11.25 4.40003C11.25 4.12389 11.0261 3.90003 10.75 3.90003L9.675 3.90003"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <rect
        x="7.5752"
        y="2.85004"
        width="2.1"
        height="6.30001"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <rect x="4.80615" y="5.75" width="2.5" height="0.5" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
    </svg>
  ),
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3.10004"
        y="3.80005"
        width="2.8"
        height="8.40001"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path
        d="M3.1 5.2001H2C1.44772 5.2001 1 5.64782 1 6.2001V9.80011C1 10.3524 1.44772 10.8001 2 10.8001H3.1"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path
        d="M12.9 10.8L14 10.8C14.5523 10.8 15 10.3523 15 9.80002L15 6.20001C15 5.64772 14.5523 5.20001 14 5.20001L12.9 5.20001"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <rect
        x="10.1"
        y="3.80005"
        width="2.8"
        height="8.40001"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <rect
        x="6.32501"
        y="7.85001"
        width="3.5"
        height="0.5"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  ),
  medium: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4.65002"
        y="5.70007"
        width="4.20001"
        height="12.6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M4.65 7.80014H2.5C1.94772 7.80014 1.5 8.24786 1.5 8.80014V15.2002C1.5 15.7524 1.94772 16.2002 2.5 16.2002H4.65"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M19.35 16.2L21.5 16.2C22.0523 16.2 22.5 15.7523 22.5 15.2L22.5 8.8C22.5 8.24771 22.0523 7.8 21.5 7.8L19.35 7.8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <rect
        x="15.15"
        y="5.70007"
        width="4.20001"
        height="12.6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <rect
        x="9.48755"
        y="11.775"
        width="5.25"
        height="0.75"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.75"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="6.20001"
        y="7.6001"
        width="5.60001"
        height="16.8"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M6.20001 10.4002H3C2.44772 10.4002 2 10.8479 2 11.4002V20.6002C2 21.1525 2.44772 21.6002 3 21.6002H6.20001"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M25.8 21.6L29 21.6C29.5523 21.6 30 21.1523 30 20.6L30 11.4C30 10.8477 29.5523 10.4 29 10.4L25.8 10.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <rect
        x="20.2"
        y="7.6001"
        width="5.60001"
        height="16.8"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <rect x="12.65" y="15.7" width="7" height="1" fill="currentColor" stroke="currentColor" />
    </svg>
  ),
};

function ExercisesIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const fSize = fontSize !== "inherit" ? fontSize : "medium";
  const content = ExercisesIcons[fSize || "medium"];

  return <SvgIcon {...props}>{content}</SvgIcon>;
}
export default ExercisesIcon;
